export const dummyLoop = [1, 2, 3]
export const dummyLoopTask = [1, 2, 3, 4]

export const TALENT_FILTER_STATUS = 'accepted'
export const RECRUIT_FILTER_STATUS = 'applied'

export const FEEDBACK_LINK =
    'https://softwareco.atlassian.net/jira/software/projects/SCE/boards/58'
